import * as React from "react";
import { ITeamRole, IDataCenter, IChangePassword } from "../../vm";
import {
  deleteShiftManager,
  getShiftManagersForDatacenter,
  updateShiftManagerPassword,
} from "../../services/shiftOperator/ShiftManagerService";
import { Loading } from "../../services/Loading";
import {
  Stack,
  Text,
  PrimaryButton,
  Fabric,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  IColumn,
  IStackTokens,
  TooltipHost,
  Callout,
  DefaultButton,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  DirectionalHint,
  ITag,
} from "office-ui-fabric-react";
import Icon from "@mdi/react";
import {
  mdiDotsVertical,
  mdiFormTextboxPassword,
  mdiPencilOutline,
  mdiTrashCanOutline,
} from "@mdi/js";
import { THEME, BRAND_SECONDARY } from "../../utils/Styles";
import NoDataTitle from "../common/NoDataTile";
import ManageShiftManager from "./ManageShiftManager";
import { childrenGap, childrenGap8, INFRA_DICT } from "../common/Constants";
import { useParams } from "react-router-dom";
import { ToastContext } from "../common/ToastProvider";
import { ConfirmDialogContext } from "../common/ConfirmDialogProvider";
import * as yup from "yup";
import { Formik, FormikErrors } from "formik";
import { CustomTextField } from "../common/Library";
import PasswordPolicy from "../common/PasswordPolicy";
import { isValidPassword } from "../../services/UtilService";
import { getAllDataCenters } from "../../services/datacenter/DatacenterService";

// const changePasswordSchema = yup.object().shape({
//   newPassword: yup
//     .string()
//     .required('required')
//     .min(5, 'Needs to be more than 4 characters'),
//   // .length(5, "Needs to be more than 4 characters"),
// });

export interface ShiftManagerMainProps {
  dataCenter: IDataCenter;
}

const ShiftManagerMain: React.FC<ShiftManagerMainProps> = ({ dataCenter }) => {
  const [state, setState] = React.useState({
    shiftManagers: [],
    manageShiftManagerDialog: {
      isOpen: false,
      index: 1,
      data: undefined,
    },
    changePassword: {
      newPassword: undefined,
      userId: undefined,
      role: undefined,
    },
    updatePassword: {
      isOpen: false,
      element: undefined,
      userId: undefined,
      role: undefined,
    },
    isLoading: false,
    isDataLoaded: false,
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      index: undefined,
      data: undefined,
    },
  } as {
    shiftManagers: ITeamRole[];
    manageShiftManagerDialog: {
      isOpen: boolean;
      index?: number;
      data?: ITeamRole;
    };
    changePassword: IChangePassword;
    updatePassword: {
      isOpen: boolean;
      element: any;
      userId?: string;
      role?: number;
    };
    isLoading: boolean;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: ITeamRole;
    };
  });
  const [datacenters, setDatacenters] = React.useState([] as ITag[]);

  //hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      setState({ ...state, isLoading: true });
      await getAllDataCenter();
      await getShiftManagers();
    };
    asyncFunc();
  }, []);

  //custom hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const childrenGap24: IStackTokens = { childrenGap: 24 };
  const wrapStackTokens: IStackTokens = { childrenGap: 16 };

  const getShiftManagers = async () => {
    // setState({ ...state, isLoading: true });
    let result = await getShiftManagersForDatacenter(params.dataCenterId);
    if (result && result.success) {
      setState({ ...state, shiftManagers: result.data, isLoading: false });
    } else {
      showToast(
        result.message || "Error while getting Shift Managers/Operators",
        "error"
      );
      setState({ ...state, isLoading: false });
    }
  };

  const getAllDataCenter = async () => {
    let result = await getAllDataCenters();
    if (result?.success) {
      let datacenters: ITag[] = [];
      result.data.forEach((d) => {
        datacenters.push({
          key: d._id as string,
          name: d.name,
        });
      });
      setDatacenters(datacenters);
    } else {
      showToast(result?.message || "Error while getting datacenters", "error");
    }
  };

  const handleCloseManageDialog = (data: ITeamRole) => {
    let shiftManagers = [...state.shiftManagers];
    if (data) {
      if (state.manageShiftManagerDialog.index !== undefined) {
        shiftManagers[state.manageShiftManagerDialog.index] = data;
        showToast(
          `${
            data.role === 0 ? "Shift Manager" : "Shift Operator"
          } updated successfully`,
          "success"
        );
      } else {
        shiftManagers.unshift(data);
        showToast(
          `${
            data.role === 0 ? "Shift Manager" : "Shift Operator"
          } added successfully`,
          "success"
        );
      }
    }
    setState({
      ...state,
      manageShiftManagerDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      shiftManagers,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const handleManageDialogOpen = (isOpen: boolean, index?: number) => {
    let shiftManager = undefined;
    if (index !== undefined) {
      shiftManager = { ...state.shiftManagers[index] };
    }
    setState({
      ...state,
      manageShiftManagerDialog: {
        isOpen: isOpen,
        index: index,
        data: shiftManager,
      },
    });
    console.log(shiftManager);
  };

  const updatePassword = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    userId?: string,
    role?: number
  ) => {
    setState({
      ...state,
      updatePassword: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        userId,
        role,
      },
      manageActionsCallout: {
        isOpen: false,
        index: undefined,
        element: undefined,
        data: undefined,
      },
    });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color={BRAND_SECONDARY}
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={`Edit ${
          //       item.role === 0 ? "Shift Manager" : "Shift Operator"
          //     }`}
          //     id={`editSm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleManageDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={"Change Password"}
          //     id={`cPDm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span
          //       onClick={(ele) =>
          //         updatePassword(true, ele, item._id, item.role)
          //       }
          //     >
          //       <Icon
          //         path={mdiFormTextboxPassword}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={`Delete ${
          //       item.role === 0 ? "Shift Manager" : "Shift Operator"
          //     }`}
          //     id={`deleteSm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteSm(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "isEnabled":
        return <span>{item.isEnabled ? "Yes" : "No"}</span>;
      case "role":
        return (
          <span>{item.role === 0 ? "Shift Manager" : "Shift Operator"}</span>
        );
      case "units": {
        return (
          <Stack horizontal wrap tokens={childrenGap8}>
            {item.units.map((unit: string, index: number) => (
              <Stack.Item key={index} className="chips">
                <span>
                  {INFRA_DICT[unit]}
                  {/* {unit.toUpperCase()} */}
                </span>
              </Stack.Item>
            ))}
          </Stack>
        );
      }
      case "name":
        return (
          <Text styles={{ root: { fontWeight: 600 } }}>
            {item[column.fieldName as any]}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const deleteSm = async (item: ITeamRole, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      `Do you want to delete ${
        item.role === 0 ? "shift manager" : "shift operator"
      }`,
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteShiftManager(item);
        if (result.success) {
          showToast(
            `${
              item.role === 0 ? "Shift Manager" : "Shift Operator"
            } deleted successfully`,
            "success"
          );
          let shiftManagers = [...state.shiftManagers];
          shiftManagers.splice(index, 1);
          setState({
            ...state,
            shiftManagers,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message ||
              `Error while deleting ${
                item.role === 0 ? "Shift Manager" : "Shift Operator"
              }`,
            "error"
          );
        }
      }
    );
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: ITeamRole
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
      updatePassword: {
        ...state.updatePassword,
        isOpen: false,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap24} className="pt-8">
        <Stack.Item>
          <Stack horizontal horizontalAlign="end">
            <Stack.Item>
              {/* <Text variant="xLarge">Shift Manager/Operator</Text> */}
            </Stack.Item>
            <Stack.Item>
              <PrimaryButton
                text="Add Shift Manager/Operator"
                onClick={() => handleManageDialogOpen(true)}
                className="borderless-btn bg-white"
              />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <div>
            {state.shiftManagers && state.shiftManagers.length > 0 ? (
              <Fabric>
                <DetailsList
                  items={state.shiftManagers}
                  columns={[
                    {
                      key: "name",
                      name: "Name",
                      fieldName: "name",
                      minWidth: 200,
                      maxWidth: 250,
                      isResizable: true,
                    },
                    {
                      key: "email",
                      name: "Email",
                      fieldName: "email",
                      minWidth: 150,
                      maxWidth: 250,
                      isResizable: true,
                    },
                    {
                      key: "role",
                      name: "Role",
                      fieldName: "role",
                      minWidth: 100,
                      maxWidth: 150,
                      isResizable: true,
                    },
                    {
                      key: "isEnabled",
                      name: "Is Enabled",
                      fieldName: "email",
                      minWidth: 100,
                      maxWidth: 150,
                      isResizable: true,
                    },
                    {
                      key: "units",
                      name: "Infrastructures",
                      fieldName: "units",
                      minWidth: 400,
                      maxWidth: 600,
                      isResizable: true,
                    },
                    {
                      key: "actions",
                      name: "Actions",
                      fieldName: "actions",
                      minWidth: 100,
                      maxWidth: 150,
                      isResizable: true,
                    },
                  ]}
                  compact={true}
                  setKey="set"
                  onRenderItemColumn={_renderItemColumn as any}
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  onRenderRow={_onRenderRow}
                />
              </Fabric>
            ) : (
              <NoDataTitle title="No Shift Manager/Operator Found"></NoDataTitle>
            )}
          </div>
        </Stack.Item>
      </Stack>
      {state.manageShiftManagerDialog.isOpen && (
        <ManageShiftManager
          data={state.manageShiftManagerDialog.data}
          datacenterId={dataCenter._id as string}
          handleLoading={handleLoading}
          closeManageDialog={(data: ITeamRole) => handleCloseManageDialog(data)}
          datacenters={datacenters}
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{
            root: {
              width: state.updatePassword.isOpen ? 300 : 180,
              padding: state.updatePassword.isOpen ? 5 : 20,
            },
          }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
          // setInitialFocus={true}
        >
          {state.updatePassword.isOpen ? (
            <Formik
              enableReinitialize
              initialValues={state.changePassword}
              // validationSchema={changePasswordSchema}
              validate={(values: any) => {
                let errors: FormikErrors<{ newPassword?: string }> = {};

                if (
                  values.newPassword &&
                  !isValidPassword(values.newPassword, false)
                ) {
                  errors.newPassword = "Please enter valid password.";
                }

                return errors;
              }}
              onSubmit={async (values: IChangePassword, { setSubmitting }) => {
                let obj = { ...values };
                obj.userId = state.updatePassword.userId;
                obj.role = state.updatePassword.role;
                let result;
                handleLoading();
                result = await updateShiftManagerPassword(
                  obj.userId as string,
                  obj.newPassword as string,
                  obj.role as number
                );
                handleLoading();
                updatePassword(false);
                handleCallOutOpenClose(false);
                if (result.success) {
                  showToast("Password updated successfully", "success");
                } else {
                  showToast(
                    result.message || "Error while updating password",
                    "error"
                  );
                }
                setSubmitting(false);
              }}
            >
              {({ handleSubmit, errors, values, touched }) => (
                <form onSubmit={handleSubmit}>
                  <Stack
                    wrap
                    tokens={wrapStackTokens}
                    styles={{ root: { padding: "10px" } }}
                  >
                    <Stack.Item>
                      <CustomTextField
                        name={"newPassword"}
                        type="password"
                        label={"Update Password"}
                        placeholder="Enter new password"
                      />
                    </Stack.Item>
                    {errors.newPassword &&
                      touched.newPassword &&
                      values.newPassword && (
                        <Stack.Item>
                          <PasswordPolicy password={values.newPassword} isAdmin={false} />
                        </Stack.Item>
                      )}
                    <Stack.Item align="end">
                      <DefaultButton
                        text="Cancel"
                        onClick={() => {
                          handleCallOutOpenClose(false);
                        }}
                        className="borderless-btn"
                      />
                      &nbsp;&nbsp;
                      <PrimaryButton text="Update" type="submit" />
                    </Stack.Item>
                  </Stack>
                </form>
              )}
            </Formik>
          ) : (
            <Stack tokens={childrenGap8}>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    handleManageDialogOpen(
                      true,
                      state.manageActionsCallout.index
                    );
                  }}
                  className="callout-options"
                >
                  Edit
                </span>
              </Stack.Item>
              <Stack.Item className="pointer">
                <span
                  onClick={
                    () =>
                      setState({
                        ...state,
                        updatePassword: {
                          ...state.updatePassword,
                          isOpen: true,
                          userId: state.manageActionsCallout.data
                            ?._id as string,
                          role: state.manageActionsCallout.data?.role,
                        },
                      })
                    // updatePassword(
                    //   true,
                    //   state.manageActionsCallout.element,
                    //   state.manageActionsCallout.data?._id as string,
                    //   state.manageActionsCallout.data?.role
                    // )
                  }
                  className="callout-options"
                >
                  Update Password
                </span>
              </Stack.Item>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    deleteSm(
                      state.manageActionsCallout.data as ITeamRole,
                      state.manageActionsCallout.index as number
                    );
                  }}
                  className="callout-options"
                >
                  Delete
                </span>
              </Stack.Item>
            </Stack>
          )}
        </Callout>
      )}
      {/* {state.updatePassword.isOpen && (
        <Callout
          styles={{ root: { width: 300 } }}
          role="alert-dialog"
          ariaLabelledBy={state.updatePassword && state.updatePassword.userId}
          target={state.updatePassword.element}
          className="ms-CalloutExample-callout"
          gapSpace={20}
          directionalHint={DirectionalHint.bottomCenter}
          onDismiss={() => updatePassword(false)}
          // setInitialFocus={true}
        >
          <Formik
            enableReinitialize
            initialValues={state.changePassword}
            // validationSchema={changePasswordSchema}
            validate={(values: any) => {
              let errors: FormikErrors<{ newPassword?: string }> = {};

              if (values.newPassword && !isValidPassword(values.newPassword)) {
                errors.newPassword = "Please enter valid password.";
              }

              return errors;
            }}
            onSubmit={async (values: IChangePassword, { setSubmitting }) => {
              let obj = { ...values };
              obj.userId = state.updatePassword.userId;
              obj.role = state.updatePassword.role;
              let result;
              handleLoading();
              result = await updateShiftManagerPassword(
                obj.userId as string,
                obj.newPassword as string,
                obj.role as number
              );
              handleLoading();
              updatePassword(false);
              if (result.success) {
                showToast("Password updated successfully", "success");
              } else {
                showToast(
                  result.message || "Error while updating password",
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({ handleSubmit, errors, values, touched }) => (
              <form onSubmit={handleSubmit}>
                <Stack
                  wrap
                  tokens={wrapStackTokens}
                  styles={{ root: { padding: "10px" } }}
                >
                  <Stack.Item>
                    <CustomTextField
                      name={"newPassword"}
                      type="password"
                      label={"Update Password"}
                      placeholder="Enter new password"
                    />
                  </Stack.Item>
                  {errors.newPassword &&
                    touched.newPassword &&
                    values.newPassword && (
                      <Stack.Item>
                        <PasswordPolicy password={values.newPassword} />
                      </Stack.Item>
                    )}
                  <Stack.Item align="end">
                    <DefaultButton
                      text="Cancel"
                      onClick={() => {
                        handleCallOutOpenClose(false);
                      }}
                      className="borderless-btn"
                    />
                    &nbsp;&nbsp;
                    <PrimaryButton text="Update" type="submit" />
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Callout>
      )} */}
    </React.Fragment>
  );
};

export default ShiftManagerMain;
